module.exports = __webpack_public_path__ + "img/plot_icon01.6aceffb2.png";